<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { assignObject } from "@/utils/UtilsIf";

export default {
  name: "partnerMaintainerShareMoney",
  components: { breadcrumbs },
  data() {
    return {
      form: {
        maintainerName: ""
      },
      multipleSelection: [],
      statistics: {
        totalOrderAmount: "",
        totalOrderCount: "",
        totalShareAmount: ""
      }
    };
  },
  mounted() {
    this.getPartnerMaintainerShareTotal();
  },
  methods: {
    search() {
      this.getPartnerMaintainerShareTotal();
      this.$refs.customTable.search();
    },
    reset() {
      this.form.maintainerName = "";
      this.getPartnerMaintainerShareTotal();
      this.$refs.customTable.search();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    indexMethod(index) {
      return index + 1;
    },
    getPartnerMaintainerShareTotal() {
      this.$api.partner.partnerMaintainerShareTotal(this.form).then(res => {
        if (res.code === 200) {
          this.statistics = assignObject(this.statistics, res.data);
        }
      });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/partner/partnerApply/partnerMaintainerShareMoneyDetail",
        query: {
          maintainerId: row.maintainerId
        }
      });
    }
  }
};
</script>

<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="pdt-15 pdb-15 bg-white">
      <el-form ref="form" :model="form" label-width="90px" inline>
        <el-form-item label="分润人姓名">
          <el-input
            v-model="form.maintainerName"
            placeholder="请输入分润人姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="$refs.customTable.search()"
            >查 询
          </el-button>
          <el-button @click="reset">重 置 </el-button>
        </el-form-item></el-form
      >
    </div>
    <!-- 统计 -->
    <div class="flex aic jcsb">
      <div class="flex aic fw-600 color0063ea mgt-20 mgb-20">
        <span class="mgr-50">分润订单数：{{ statistics.totalOrderCount }}</span>
        <span class="mgr-50"
          >分润订单金额（元）：{{ statistics.totalOrderAmount }}</span
        >
        <span class="mgr-50">分润金额（元）：{{ statistics.totalShareAmount }}</span>
      </div>
    </div>

    <customTable
      ref="customTable"
      :api="$api.partner.partnerMaintainerShareTotalList"
      :params="form"
      @selection-change="handleSelectionChange"
    >
      <template #columns>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="maintainerName" label="分润人姓名">
        </el-table-column>
        <el-table-column prop="totalProfitAmount" label="订单总分润金额（元）">
        </el-table-column>
        <el-table-column prop="totalRewardAmount" label="新用户单笔奖励（元）">
        </el-table-column>
        <el-table-column prop="totalIncome" label="总收益（元）">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDetail(scope.row)"
              >详情
            </el-button>
          </template>
        </el-table-column>
      </template>
    </customTable>
  </div>
</template>

<style scoped lang="scss"></style>
